import { render } from "./App.vue?vue&type=template&id=a575069a&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=a575069a&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=a575069a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a575069a"]])

export default __exports__